import React, { useState } from "react";
import {
  SubmenuLogo,
  SizeOptions,
  SizeOption,
  PositionOptions,
  PositionOption,
  SizeLabel,
  RadioButton,
  Dropdown,
  LogoPositionLabel,
  ApplyButton,
  CenterIcon,
} from "./SidebarStyles";
import addLogo from "../Frames/addLogo";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
const LogoSubmenu = ({
  isVisible,
  photos,
  selectedPhotos,
  setAllPhotos,
  setLoadingPhotoIds,
  setAcceptedPhotos,
  originalImages,
  setOriginalImages,
  originalImagesLogo,
  setOriginalImagesLogo,
  logo,
}) => {
  const [size, setSize] = useState("small");
  const [logoPosition, setLogoPosition] = useState("bottom-left");

  const handleAddLogo = async () => {
    setLoadingPhotoIds(selectedPhotos);

    for (const photoId of selectedPhotos) {
      const photo = photos.find((p) => p.id === photoId);
      if (photo) {
        // Wait for addLogo to complete for each photo
        await new Promise(async (resolve) => {
          await addLogo(
            photo,
            logoPosition,
            size,
            logo,
            photoId,
            originalImages,
            setOriginalImages,
            originalImagesLogo,
            setOriginalImagesLogo,
            setAllPhotos,
            setAcceptedPhotos
          );

          // Update the state once the logo is added
          setAllPhotos((prevPhotos) =>
            prevPhotos.map((p) =>
              p.id === photoId
                ? { ...p, logoAdded: true, logoPosition, size }
                : p
            )
          );

          // Immediately remove the current photo from loadingPhotoIds to update the blur effect
          setLoadingPhotoIds((prevIds) =>
            prevIds.filter((id) => id !== photoId)
          );

          resolve();
        });
      }
    }
  };

  if (!isVisible) return null;

  return (
    <SubmenuLogo>
      <Dropdown>
        <LogoPositionLabel>Logo Size:</LogoPositionLabel>
        <SizeOptions>
          <SizeOption>
            <RadioButton
              type="radio"
              id="small"
              name="logo-size"
              value="small"
              checked={size === "small"}
              onChange={(e) => setSize(e.target.value)}
            />
            <SizeLabel htmlFor="small" size="small">
              S
            </SizeLabel>
          </SizeOption>
          <SizeOption>
            <RadioButton
              type="radio"
              id="medium"
              name="logo-size"
              value="medium"
              checked={size === "medium"}
              onChange={(e) => setSize(e.target.value)}
            />
            <SizeLabel htmlFor="medium" size="medium">
              M
            </SizeLabel>
          </SizeOption>
          <SizeOption>
            <RadioButton
              type="radio"
              id="large"
              name="logo-size"
              value="large"
              checked={size === "large"}
              onChange={(e) => setSize(e.target.value)}
            />
            <SizeLabel htmlFor="large" size="large">
              L
            </SizeLabel>
          </SizeOption>
        </SizeOptions>

        <LogoPositionLabel>Logo Position:</LogoPositionLabel>
        <PositionOptions>
          <PositionOption style={{ marginLeft: "10px", marginTop: "20px" }}>
            <RadioButton
              type="radio"
              id="top-left"
              name="logo-position"
              value="top-left"
              checked={logoPosition === "top-left"}
              onChange={(e) => setLogoPosition(e.target.value)}
            />
          </PositionOption>
          <PositionOption style={{ marginTop: "20px" }}>
            <RadioButton
              type="radio"
              id="top-right"
              name="logo-position"
              value="top-right"
              checked={logoPosition === "top-right"}
              onChange={(e) => setLogoPosition(e.target.value)}
            />
          </PositionOption>
          <CenterIcon>
            <PersonOutlineOutlinedIcon style={{ width: '80px', height: '80px' }} />
          </CenterIcon>
          <PositionOption style={{ marginLeft: "10px", marginBottom: "20px" }}>
            <RadioButton
              type="radio"
              id="bottom-left"
              name="logo-position"
              value="bottom-left"
              checked={logoPosition === "bottom-left"}
              onChange={(e) => setLogoPosition(e.target.value)}
            />
          </PositionOption>
          <PositionOption style={{ marginBottom: "20px" }}>
            <RadioButton
              type="radio"
              id="bottom-right"
              name="logo-position"
              value="bottom-right"
              checked={logoPosition === "bottom-right"}
              onChange={(e) => setLogoPosition(e.target.value)}
            />
          </PositionOption>
        </PositionOptions>
        <ApplyButton onClick={() => handleAddLogo()}>
          Add school logo
        </ApplyButton>
      </Dropdown>
    </SubmenuLogo>
  );
};

export default LogoSubmenu;
